import { render, staticRenderFns } from "./AppStoreRedirectCard.vue?vue&type=template&id=48456c14"
import script from "./AppStoreRedirectCard.vue?vue&type=script&lang=js"
export * from "./AppStoreRedirectCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports